import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { RawAlarmsComponent } from "./raw-alarms/raw-alarms.component";
import { IndividualAlarmsComponent } from "./individual-alarms/individual-alarms.component";

@Component({
  selector: 'app-alarms',
  standalone: true,
  imports: [
    CommonModule,
    TranslateModule,
    RawAlarmsComponent,
    IndividualAlarmsComponent
  ],
  templateUrl: './alarms.component.html',
  styleUrls: ['./alarms.component.scss'],
})
export class RealTimeEventsComponent {

  activeTab: string = 'all-events';
  isSelectOptionOpen = false;
  selectedAlarmTab: string = 'all-events';

  toggleSelectOption(): void {
    this.selectedAlarmTab = this.activeTab;
    this.isSelectOptionOpen = !this.isSelectOptionOpen;
  }

  closeSelectOption(): void {
    this.isSelectOptionOpen = false;
  }

  selectAlarmTab(tab: string): void {
    this.selectedAlarmTab = tab;
  }

  applyAlarmTab(): void {
    this.activeTab = this.selectedAlarmTab;
    this.closeSelectOption();
  }
}
